import { Alert, Box } from '@mui/material';
import React from 'react';
import { loadScript } from '../utils/loadScript';
/**
 * This Component loads Altcha CDN modules https://cdnjs.juvare.com/ajax/libs/altcha/1.1.0/altcha.min.js
 * Waits for scripts to be loaded and then renders children
 */
export const AltchaCdn = ({ loadingFallback, children }) => {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
        const scriptUrl = 'https://cdnjs.juvare.com/ajax/libs/altcha/1.1.0/altcha.min.js';
        loadScript(scriptUrl, { type: 'module' })
            .then(() => setLoaded(true))
            .catch(() => setError(true));
    }, []);
    if (loaded) {
        return children;
    }
    else if (error) {
        return React.createElement(Alert, { severity: 'error' }, "Error loading ALTCHA");
    }
    else {
        return loadingFallback !== null && loadingFallback !== void 0 ? loadingFallback : React.createElement(Box, null, "Loading...");
    }
};
